import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { USER_MODE } from '../constants';
import PillButtonGroup from '../../../../../components/global/PillButtonGroup';

const propTypes = {
  userMode: PropTypes.oneOf(Object.values(USER_MODE)).isRequired,
  setUserMode: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
};

const SignInMethodToggles = ({ userMode, setUserMode, hidden }) => {
  if (hidden) {
    return null;
  }

  return (
    <PillButtonGroup className="mb-3 shutterbug-login-pill-group">
      <button
        className={classNames({
          active: userMode === USER_MODE.SHUTTERBUG,
        })}
        onClick={() => setUserMode(USER_MODE.SHUTTERBUG)}
        type="button"
      >
        Personal
      </button>

      <button
        className={classNames({
          active: [USER_MODE.PRO, USER_MODE.TEAM].includes(userMode),
        })}
        onClick={() =>
          setUserMode(
            userMode === USER_MODE.TEAM ? USER_MODE.TEAM : USER_MODE.PRO,
          )
        }
        type="button"
      >
        Business
      </button>
    </PillButtonGroup>
  );
};

SignInMethodToggles.propTypes = propTypes;

export default SignInMethodToggles;
